import { render } from "./Android.vue?vue&type=template&id=27ea53be&scoped=true"
import script from "./Android.vue?vue&type=script&lang=js"
export * from "./Android.vue?vue&type=script&lang=js"

import "./Android.vue?vue&type=style&index=0&id=27ea53be&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27ea53be"]])

export default __exports__